import React from 'react'
import { AgendamentoRetornoCliente } from '../AgendamentoRetornoCliente'
import { AiFillPlusCircle } from 'react-icons/ai'
import { Icon } from '@chakra-ui/react'

export function RetornarEm({ numeroNota, infoProposta, pedidoBloqueado }) {
  return (
    <AgendamentoRetornoCliente numeroNota={numeroNota} infoProposta={infoProposta} pedidoBloqueado={pedidoBloqueado}>
      <Icon as={AiFillPlusCircle} color="#378BBF" fontSize="20px" cursor="pointer" />
    </AgendamentoRetornoCliente>
  )
}
